module.exports = __webpack_public_path__ + "static/media/lcbot.0ba98828.svg";